@if (riskScore) {
  <div class="risk-score">
    <div class="risk-score-widget g-display-flex">
      <app-ui-icon-number-text-widget
        [numberValue]="riskScore"
        [title]="title"
        [numeratorClass]="numeratorClass"
        [variant]="riskIconVariant"
        [isResponsive]="true"
      ></app-ui-icon-number-text-widget>
      <app-icon class="risk-icon" [svgIcon]="IconsEnum.info"></app-icon>
    </div>
    <app-ui-risk-score-tooltip
      class="risk-score-tooltip"
      [title]="riskTexts.tooltip_title"
      [theme]="UiTooltipThemeEnum.white">
    </app-ui-risk-score-tooltip>
  </div>
}
